import { Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpUrlEncodingCodec } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { isNullOrEmpty } from '@awp/core/utils';
import { RESPONSE_LOGGER_TOKEN } from '../response-console.logger';
import { ROUTE_PARAM_REGEX } from './siren-http.service';
import { SirenCache } from './siren-cache';
import * as i0 from "@angular/core";
var SirenClient = /** @class */ (function () {
    function SirenClient(parentInjector) {
        this._headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this._encoder = new HttpUrlEncodingCodec();
        this._injector = parentInjector;
    }
    SirenClient.prototype.getClient = function () {
        if (this._httpClient == null) {
            this._httpClient = this._injector.get(HttpClient);
        }
        return this._httpClient;
    };
    SirenClient.prototype.get = function (link, param) {
        if (link == null) {
            throw new Error('Link is not defined');
        }
        var sirenLink = this.resolveSirenLink(link);
        var loggers = (this._injector.get(RESPONSE_LOGGER_TOKEN) || []);
        var parsedUrl = this.parseUrlRouteParams(sirenLink.href, param ? param.route : null);
        var cache = this.cache;
        var rel = sirenLink.rel != null ? sirenLink.rel[0].replace('rel/', '') : null;
        var linkHeaders = rel != null ? this._headers.set('Siren', rel) : this._headers;
        return this.getClient().get(parsedUrl, {
            headers: linkHeaders,
            params: param != null ? param.queryParams : null,
        })
            .pipe(tap(function (response) {
            cache.setResponse(response.rel[0], response);
        }), tap(function (response) {
            loggers.forEach(function (logger) {
                logger.log(parsedUrl, response);
            });
        }));
    };
    SirenClient.prototype.getBlob = function (link, param) {
        if (link == null) {
            throw new Error('Link is not defined');
        }
        var url = (typeof link === 'string') ? link : link.href;
        var parsedUrl = this.parseUrlRouteParams(url, param ? param.route : null);
        return this._httpClient.get(parsedUrl, { headers: this._headers, responseType: 'blob' });
    };
    SirenClient.prototype.post = function (action, request, param) {
        if (action == null) {
            throw new Error('Action is not defined');
        }
        var sirenAction = this.resolveActionUrl(action);
        var loggers = (this._injector.get(RESPONSE_LOGGER_TOKEN) || []);
        var parsedUrl = this.parseUrlRouteParams(sirenAction.href, param ? param.route : null);
        var cache = this.cache;
        var actionHeaders = sirenAction.name != null ? this._headers.set('Siren', sirenAction.name) : this._headers;
        return this.getClient().request(sirenAction.method || 'POST', parsedUrl, {
            body: request,
            params: param != null ? param.queryParams : null,
            headers: actionHeaders
        })
            .pipe(tap(function (response) {
            cache.setResponse(response.rel[0], response);
        }), tap(function (response) {
            loggers.forEach(function (logger) {
                logger.log(parsedUrl, response);
            });
        }));
    };
    SirenClient.prototype.parseUrlRouteParams = function (url, params) {
        var _this = this;
        if (params == null)
            return url;
        var result = url.replace(ROUTE_PARAM_REGEX, function (match, key) {
            var value = params[key];
            var encodedValue = isNullOrEmpty(value) ? value : _this._encoder.encodeValue(value);
            return encodedValue;
        });
        return result;
    };
    Object.defineProperty(SirenClient.prototype, "cache", {
        get: function () {
            if (this._cache == null) {
                this._cache = this._injector.get(SirenCache);
            }
            return this._cache;
        },
        enumerable: true,
        configurable: true
    });
    SirenClient.prototype.getAction = function (name) {
        return this.cache.getAction(name);
    };
    SirenClient.prototype.getResponse = function (name) {
        return this.cache.getResponse(name);
    };
    SirenClient.prototype.getLink = function (name) {
        return this.cache.getLink(name);
    };
    SirenClient.prototype.resolveSirenLink = function (value) {
        var result;
        if (typeof value === 'string') {
            if (!value.startsWith('http')) {
                var linkRef = this.getLink(value); // resolve the link name
                if (linkRef == null) {
                    throw new Error('Link not found');
                }
                result = linkRef;
            }
            else {
                result = { href: value, rel: ['unknown'] };
            }
        }
        else {
            result = value;
        }
        return result;
    };
    SirenClient.prototype.resolveActionUrl = function (value) {
        var result;
        if (typeof value === 'string') {
            if (!value.startsWith('http')) {
                var actionRef = this.getAction(value); // resolve the action name
                if (actionRef == null) {
                    throw new Error('Action not found');
                }
                result = actionRef;
            }
            else {
                result = { href: value, method: 'POST', name: 'unknown' }; // Assume POST
            }
        }
        else {
            result = value;
        }
        return result;
    };
    SirenClient.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SirenClient_Factory() { return new SirenClient(i0.ɵɵinject(i0.INJECTOR)); }, token: SirenClient, providedIn: "root" });
    return SirenClient;
}());
export { SirenClient };
